import { emailValidation } from './base'
import { validator } from './core'

export const EmailValidateSchema = validator.object().shape({
  email: emailValidation(),
})
